import { Link, useParams } from "react-router-dom";
import { groups } from "../data";
import { overviewContent } from "../content";
import { ArrowIcon } from "../components/Icons";
import Seo from "../components/Seo";

export default function OverviewPage({ groupKey }) {
  const params = useParams();
  const key = groupKey || params.group;
  const group = groups[key];
  const content = overviewContent[key];

  if (!group || !content) return null;

  return (
    <>
      <Seo title={group.title} description={group.description} />
      <section className={`inner-hero overview-hero overview-hero-${key}`} id="overview">
        <div className="inner-hero-copy">
          <p className="section-label">{key.replace("-", " ")}</p>
          <h1>{group.title}</h1>
          <p className="inner-lead">{group.lead}</p>
          <p>{group.description}</p>
          <div className="button-row">
            <Link className="button button-primary" to="/partnership">
              Discuss a program <ArrowIcon />
            </Link>
            <Link className="button button-secondary" to="#explore">
              Explore capabilities <ArrowIcon />
            </Link>
          </div>
        </div>
        <div className={`inner-hero-media hero-media-${key}`}>
          <img src={group.image} alt={`${group.title} scientific capability`} fetchPriority="high" decoding="async" />
          <span className="media-caption">{group.title} — Medein capability system</span>
        </div>
      </section>

      <section className="section overview-intro" id="system">
        <div>
          <p className="section-label">System overview</p>
          <h2>{content.introTitle}</h2>
        </div>
        <p>{content.intro}</p>
      </section>

      <section className="overview-flow" id="workflow">
        <div>
          <p className="section-label">Connected workflow</p>
          <h2>{content.flowTitle}</h2>
        </div>
        <ol>
          {content.flow.map((step, index) => (
            <li key={step}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <strong>{step}</strong>
            </li>
          ))}
        </ol>
      </section>

      <section className="section overview-list-section" id="explore">
        <div className="section-heading split-heading">
          <div>
            <p className="section-label">Explore</p>
            <h2>{key === "pipeline" ? "Programs and evidence" : "Capabilities and pathways"}</h2>
          </div>
          <p>
            Public content is reviewed for scientific context, status, evidence level, and access requirements.
          </p>
        </div>
        <div className="overview-list">
          {group.items.map((item, index) => (
            <Link key={item.slug} to={`/${key}/${item.slug}`}>
              <span className="overview-index">{String(index + 1).padStart(2, "0")}</span>
              <img src={item.icon} alt="" />
              <div>
                <span>{item.area || item.status || key}</span>
                <h3>{item.title}</h3>
                <p>{item.short}</p>
              </div>
              <ArrowIcon />
            </Link>
          ))}
        </div>
      </section>

      <section className="section overview-values" id="principles">
        <div className="section-heading">
          <p className="section-label">Operating principles</p>
          <h2>Built for clarity, evidence, and translation.</h2>
        </div>
        <div className="context-grid">
          {content.values.map((value, index) => (
            <article key={value.title}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <h3>{value.title}</h3>
              <p>{value.text}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="governance-callout">
        <div>
          <p className="section-label">Evidence by design</p>
          <h2>Clarity before claims.</h2>
        </div>
        <p>
          Every item carries a content owner, scientific reviewer, evidence level, status, region, review date,
          and access classification before publication.
        </p>
        <Link className="text-link" to="/contact">Request information <ArrowIcon /></Link>
      </section>
    </>
  );
}
